export const EPIC_LABEL = 'Subcard of:';
export const EPIC_ARCHIVED = 'Archived';
export const EPIC_TOOLTIP = 'Epic:';
